import FullWidthHeaderAdvanced from "@components/BasicComponents/FullWidthHeader/FullWidthHeaderAdvanced"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import Winter25RegistrationFinlandTopSection from "@components/Pages/Forms/Winter25RegistrationFinland/Winter25RegistrationFinlandTopSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import finlandWinterRegistration25 from "@jsons/finlandWinterRegistration25.json"

export default function finlandWinterRegistrationPage(): JSX.Element {
	const pageData = getTranslatedPageData(
		finlandWinterRegistration25,
		undefined,
		true,
		"one",
		"fi",
	)
	const {changeLocale: changeLocaleCustome} = useLocale()
	changeLocaleCustome("fi")
	const list = getValueOrThrow(pageData.AdvancedSideAsset)
	return (
		<div className={"one"}>
			<HeadMeta meta={pageData.metaData} />
			<FullWidthHeaderAdvanced
				data={getValueOrThrow(pageData.heroData?.[0])}
				overlayColor={"#175eeb"}
				withOverlay
			/>
			<Winter25RegistrationFinlandTopSection data={list[0]} />
			<Separator size={64} />
			<div id={"book-a-demo"} />
			<ContainerWrapper>
				<Title content={list[1].sectionTitle} size={"XL"} center />
				{/* <Title
					content={"Ilmoittautuminen päättyi"}
					size={"XL"}
					center
				/> */}
				{/* <Winter25RegistrationFinlandForm
					button={list[1].sectionBottomButton}
				/> */}
			</ContainerWrapper>
			<Separator size={64} />
		</div>
	)
}
